<!-- Backdrop -->
<div
        class="customizer-backdrop"
        *ngIf="isCustomizerOpen"
        (click)="toggleCustomizer()"
></div>

<div

        class="customizer fade"
        [class.show]="isCustomizerOpen"
        [class.d-block]="isCustomizerOpen"
        [ngStyle]="{ width: customizerWidth }"
>
    <div class="customizer-content">
        <!-- Header -->
        <div class="customizer-header px-2 pt-1 pb-0 position-relative">
            <h4 class="mb-0">DOC-000X</h4>

            <a class="customizer-close" (click)="toggleCustomizer()">
                <span [data-feather]="'x'"></span>
            </a>
        </div>

        <hr/>

        <!-- Body -->
        <div class="customizer-body px-2">
            <div class="row">
                <div *ngIf="showContactInfo" class="col-lg-6">
                    <b>Client</b>

                    <table class="table mt-2">
                        <tbody>
                        <tr>
                            <td>Entreprise</td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <td>Numéro d'identification fiscale</td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <td>Responsable</td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <td>Adresse</td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>--</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
                <div class="col-lg-6">
                    <b>Détails du document</b>

                    <table class="table mt-2">
                        <tbody>
                        <tr>
                            <td>Date</td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <td>Date d”échéance</td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <td>Entrepot</td>
                            <td>tous les entrepot</td>
                        </tr>
                        <tr>
                            <td>Projet</td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <td>Note</td>
                            <td>--</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
                <div class="col-lg-12">
                    <table class="table">
                        <thead>


                        <th>Désignation</th>
                        <th>Quantité</th>
                        <th>Prix HT</th>
                        <th>TVA</th>
                        <th>TOTAL ht</th>

                        </thead>
                        <tbody>
                        <tr>

                            <td>P-0000001 Produit 1</td>
                            <td>1000</td>
                            <td>420,168 TND</td>
                            <td>13</td>
                            <td>420,168 TND</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="showTotals" class="col-lg-12 mt-5">
                    <div class="row container d-flex">

                        <div class="card">
                            <div class="card-body">
                                <table class="table">
                                    <thead>
                                    <th>TVA</th>
                                    <th>Prix HT</th>
                                    <th>tOTAL ht</th>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>13</td>
                                        <td>420,168 TND</td>
                                        <td>54,622 TND</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-lg-1"></div>
                        <div class="card d-flex justify-content-end" style="margin-right:0">
                            <div class="card-body">
                                <table class="table">
                                    <tbody>
                                    <tr>
                                        <td><b>Total HT</b></td>
                                        <td>54,622 TND</td>

                                    </tr>
                                    <tr>
                                        <td><b>Total TVA</b></td>
                                        <td>54,622 TND</td>

                                    </tr>
                                    <tr>
                                        <td><b>Total TTC</b></td>
                                        <td>54,622 TND</td>

                                    </tr>

                                    <tr>
                                        <td><b>Net à payer</b></td>
                                        <td>54,622 TND</td>

                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="col-lg-12">
                    <div  *ngIf="showDescription" class="d-flex">
                        <div class="card col-md-4">
                            <div class="card-body">
                                <dd><b>Entreprise</b></dd>
                                <dd>Shopi</dd>
                                <dd>l'aaouina cité wahat, tunis</dd>
                                <dd>null tunis</dd>
                                <dd>Matricule fiscal: 5885</dd>
                            </div>

                        </div>
                        <div class="card col-md-4">
                            <div class="card-body">
                                <dd><b>Coordonnées</b></dd>
                                <dd>--</dd>
                                <dd>--</dd>
                                <dd>--</dd>
                                <dd>--</dd>
                            </div>
                        </div>
                        <div class="card col-md-4">
                            <div class="card-body">
                                <dd><b>Coordonnées bancaires</b></dd>
                                <dd>STB-Société Tunisienne de Banque
                                    TN5910006035183598478831
                                </dd>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
